



















































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
  // import {json2excel} from "js2excel";
import GlobalMixins from "@/global.mixin";
import {importExportApi} from "../../services/api/importexport.api";
import appSnackbarService from "@/services/appSnackbar.service";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class InventoryDetailView extends Vue {

  @State("inventoryDetails") inventoryDetailsState: any;
  @State("costCenters") costCentersState: any;

  @Action("getProducts") getProducts: any;
  @Action("getInventoryItems") getInventoryItems: any;
  @Action("getCostCenters") getCostCenters: any;
  @Action("updateCostCenter") updateCostCenter: any;

  downloading = false;

  dialog = false;
  dialogDelete = false;
  costCenterDialog = false;
  costCentersSearchTerm = "";
  costCentersSearched: any[] = [];
  selectedCostCenterId: number | null = null;
  currentInventoryItem: any = null;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "inventoryItemId",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("inventoryItems-rowsPerPage") ?
                        parseInt(this.$cookies.get("inventoryItems-rowsPerPage"), 10) : 25
  };

  search = "";
  editedIndex = -1;
  defaultItem = {
    barcode: "",
    description: "",
  };
  editedItem = Object.assign({}, this.defaultItem);

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  async created() {
    // this.updateData();
    await this.getCostCenters();
    this.searchCostCenters(null);
  }
  getHeaders() { return [
      { text: "#", value: "inventoryId", width: "1%", align: "left"},
      { text: this.$t("INVENTORY_DETAILS_TABLE_BARCODE"), value: "barCode", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_NAME"), value: "productDescription", sortable: true, align: "left",  },
      { text: "Költséghely", value: "origSiteCode", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_NEW_SITE"), value: "siteCode", sortable: true, align: "left",  },
      { text: "Új Költséghely", value: "costCenterName", sortable: true, align: "left",  },
      { text: this.$t("INVENTORY_DETAILS_TABLE_READ_DT"),  value: "createdDate", sortable: true, align: "left", },
      { text: this.$t("INVENTORY_DETAILS_TABLE_USER"),  value: "userFullName", sortable: true, align: "left", },
      // { text: this.$t("TABLE_ACTIONS"), value: "actions", sortable: false },
      { text: "", value: "actions", sortable: false },
    ];
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  updatePagination(pagination) {
    this.$cookies.set("inventoryItems-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      id: this.$route.params.inventoryId,
    };
    this.getInventoryItems(page);
  }


  back() {
    this.$router.back();
  }

  download() {

    const pagination = this.pagination;
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      id: this.$route.params.inventoryId,
    };

    // this.downloading = true;

    importExportApi.downloadInventoryExport(page, "leltar-reszletek.xlsx");
  }

  async selectCostCenter(item) {
    this.currentInventoryItem = item;
    this.selectedCostCenterId = item.costCenterId ? item.costCenterId : null;
    this.costCentersSearchTerm = "";

    // Filter cost centers by SiteId
    this.searchCostCenters(null);

    this.costCenterDialog = true;
  }

  searchCostCenters(e) {

    // Then filter by search term if provided
    if (!this.costCentersSearchTerm) {
      this.costCentersSearched = this.costCentersState.costCenters;
      return;
    }

    const searchTerm = this.costCentersSearchTerm.toLowerCase();
    this.costCentersSearched = this.costCentersState.costCenters.filter((item: any) => {
      return item.name.toLowerCase().indexOf(searchTerm) > -1 ||
             item.description.toLowerCase().indexOf(searchTerm) > -1;
    });
  }

  closeCostCenterDialog() {
    this.costCenterDialog = false;
    this.currentInventoryItem = null;
    this.selectedCostCenterId = null;
    this.costCentersSearchTerm = "";
  }

  async saveCostCenter() {
    if (!this.currentInventoryItem || !this.selectedCostCenterId) {
      return;
    }

    try {
      await this.updateCostCenter({
        inventoryItemId: this.currentInventoryItem.inventoryItemId,
        costCenterId: this.selectedCostCenterId
      });

      this.closeCostCenterDialog();
      appSnackbarService.success(this.$t("SUCCESS_MESSAGES.COST_CENTER_SAVED") || "Költséghely mentve");
    } catch (error) {
      if (error.error) {
        appSnackbarService.error("Hiba történt a költséghely mentésekor: " + error.error);
      } else {
        appSnackbarService.error("Hiba történt a költséghely mentésekor!");
      }
      console.error("Error saving cost center:", error);
    }
  }
}
